export default __webpack_public_path__ + "static/media/info-circle.b1a62344.svg";